import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { useIntl } from 'react-intl';
import getLineGraphOptions from 'utils/get-line-graph-options';
import { TemperatureProfile as TemperatureProfileProps } from 'views/site-settings/features/general-settings/types/temperature-profile.type';

type ChartProps = {
  data: TemperatureProfileProps[];
};

const AverageTemperatureChart: React.FC<ChartProps> = ({ data }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'siteSettings.editSiteSettings.temperatureProfile';

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={
        {
          legend: {
            enabled: false,
          },
          defs: {
            patterns: [
              {
                id: 'custom-pattern',
                path: {
                  d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                  stroke: '#f0f0f0',
                  strokeWidth: 1,
                },
                opacity: 0.9,
              },
            ],
          },
          ...getLineGraphOptions({
            xAxisTitle: intl.formatMessage({ id: `general.week` }),
            yAxisTitle: intl.formatMessage({ id: `general.degrees` }),
            formatNumber: intl.formatNumber,
          }),
          series: [
            {
              type: 'area',
              name: intl.formatMessage({ id: `${PAGE_NAME_ID}.title` }),
              lineColor: '#0BB14D',
              color: 'url(#custom-pattern)',
              data: data.map((row) => ({
                x: row.weekNumber,
                y: parseFloat(Number(row.averageTemperature).toFixed(2)),
                name: intl.formatMessage({ id: `general.chartWeek` }, { row: row?.weekNumber }),
              })),
              tooltip: {
                valueSuffix: ' °C',
              },
            },
          ] as Highcharts.SeriesOptionsType[],
        } as Highcharts.Options
      }
    />
  );
};

export default AverageTemperatureChart;
